var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"disabled":_vm.busy,"variant":"link"},on:{"click":_vm.valuation_download}},[(!_vm.busy)?_c('font-awesome-icon',{attrs:{"icon":"fa-regular fa-file-chart-column"}}):_vm._e(),(_vm.busy)?_c('b-spinner',{attrs:{"small":""}}):_vm._e(),_c('span',[_vm._v("Cost of Goods")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }